// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Visit ${i.handle} on Instagram`
};

const de_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Besuche ${i.handle} auf Instagram`
};

const es_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Visitar ${i.handle} en Instagram`
};

const fr_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Visiter ${i.handle} sur Instagram`
};

const fi_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Vieraile ${i.handle} Instagram-profiilissa`
};

const hi_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Instagram पर ${i.handle} की प्रोफाइल देखें`
};

const ja_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Instagramで${i.handle}を訪問`
};

const nl_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Bezoek ${i.handle} op Instagram`
};

const pt_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Visitar ${i.handle} no Instagram`
};

const ro_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Vizitează ${i.handle} pe Instagram`
};

const th_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `เยี่ยมชม ${i.handle} บน Instagram`
};

const ur_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.handle} کو انسٹاگرام پر دیکھیں`
};

const zh_hant1_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `在 Instagram 上訪問 ${i.handle} 的個人資料`
};

const da_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Besøg ${i.handle} på Instagram`
};

const it_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Visita ${i.handle} su Instagram`
};

const vn_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Thăm ${i.handle} trên Instagram`
};

const ko_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Instagram에서 ${i.handle} 방문하기`
};

const tr_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Instagram'da ${i.handle} profilini ziyaret et`
};

const lv_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Apmeklējiet ${i.handle} Instagram`
};

const ar_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `زر ${i.handle} على إنستغرام`
};

const bs_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Posjetite ${i.handle} na Instagramu`
};

const sl_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Obiščite ${i.handle} na Instagramu`
};

const id_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Kunjungi ${i.handle} di Instagram`
};

const sv_widget_actions_visit_profile_on_instagram = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Besök ${i.handle} på Instagram`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ handle: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_actions_visit_profile_on_instagram = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_actions_visit_profile_on_instagram(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_actions_visit_profile_on_instagram", locale)
	if (locale === "en") return en_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "de") return de_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "es") return es_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "fr") return fr_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "fi") return fi_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "hi") return hi_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "ja") return ja_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "nl") return nl_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "pt") return pt_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "ro") return ro_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "th") return th_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "ur") return ur_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "da") return da_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "it") return it_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "vn") return vn_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "ko") return ko_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "tr") return tr_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "lv") return lv_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "ar") return ar_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "bs") return bs_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "sl") return sl_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "id") return id_widget_actions_visit_profile_on_instagram(inputs)
	if (locale === "sv") return sv_widget_actions_visit_profile_on_instagram(inputs)
	return "widget_actions_visit_profile_on_instagram"
};